/**
 * Whether the page being viewed may carry ads, decided by the page itself.
 *
 * AppThemed loads the AdSense script once per visit, and with Auto ads on in the account that
 * script places ads anywhere — the live view and the registration page included, which hold no
 * ad units of their own. Both belong to a club, and a Plus club buys ad-free pages (`hide_ads` on
 * the event payload, decided server-side from the OWNING club, never the viewer). Those pages
 * cannot answer until the event has loaded, so on their paths the script waits for the page to
 * declare, and loads only on "show". Every other path behaves as before.
 */
const GATED = [/^\/live\/(t|tournaments|l|leagues)\//, /^\/e\//];

type Listener = () => void;

let decision: boolean | null = null;
const listeners = new Set<Listener>();

/** True on a path whose page decides about ads itself. */
export function adsGatedOn(pathname: string): boolean {
    const path = pathname.endsWith('/') ? pathname : pathname + '/';

    return GATED.some((re) => re.test(path));
}

/** The page says whether ads may load: null until it has. */
export function pageAdsDecision(): boolean | null {
    return decision;
}

/** Called by a gated page once its event has loaded. */
export function declarePageAds(show: boolean): void {
    if (decision === show) return;
    decision = show;
    listeners.forEach((fn) => fn());
}

export function subscribePageAds(fn: Listener): () => void {
    listeners.add(fn);

    return () => {
        listeners.delete(fn);
    };
}

/** Tests only. */
export function resetPageAds(): void {
    decision = null;
}
